'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    'zh-cn': {
        today: '今天',
        now: '此刻',
        ok: '确定',
        clear: '清除',
        month: '月',
        year: '年',
        prevYear: '上一年',
        nextYear: '下一年',
        prevMonth: '上个月',
        nextMonth: '下个月',
        monthSelect: '选择月份',
        yearSelect: '选择年份',
        decadeSelect: '选择年代'
    },
    'zh-tw': {
        today: '今天',
        now: '此刻',
        ok: '確定',
        clear: '清除',
        month: '月',
        year: '年',
        prevYear: '上一年',
        nextYear: '下一年',
        prevMonth: '上个月',
        nextMonth: '下个月',
        monthSelect: '選擇月份',
        yearSelect: '選擇年份',
        decadeSelect: '選擇年代'
    },
    'en-us': {
        today: 'Today',
        now: 'Now',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        prevYear: 'Previous year',
        nextYear: 'Next year',
        prevMonth: 'Previous month',
        nextMonth: 'Next month',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade'
    }
};

exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web-ui@1/node_modules/_@bone_bone-web-ui@1.0.7@@bone/bone-web-ui/lib/_components/@alife/next-calendar/lib/locale/index.js
// module id = 1811
// module chunks = 2